<script setup lang="ts">

import type {RouterTab} from "@/types/tabs";
import RouterTabs from "@/components/_common/RouterTabs.vue";

const items: RouterTab[] = [
  {routeName: 'GeofenceListView', title: 'Geofences'},
  {routeName: 'AnchorsListView', title: 'BLE Anchors'},
]
</script>

<template>
  <RouterTabs :items="items" />
</template>
